export default __webpack_public_path__ + "finance_m8c4c3e.jpg";